import { Outlet } from "react-router-dom";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import Navbar from "../../../../components/navbar/navbar";
import Footer from "../../../../components/footer/Footer";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import Information from "../../../home-amc/information/information";
import BreadCrumb from "../../../../components/breadcrumb/breadcrumb";

function NationalsMain() {
  const [tSMetaData] = useTranslation("metaData");
  return (
    <div>
      <Helmet>
        <title>{tSMetaData("nacionales.title")}</title>
        <meta
          name="description"
          content={tSMetaData("nacionales.description")}
        />
      </Helmet>
      <ScrollToTop />
      <Information />
      <Navbar />
      <BreadCrumb />
      <Outlet />
      <Footer />
    </div>
  );
}

export default NationalsMain;
